import React from 'react'
import { View } from 'styles/reactnative'

const TableColumns = ({ children, onClick }) => {
	return (
		<View
			onClick={onClick}
			style={{
				width: '100%',

				alignItems: 'flex-start',
				justifyContent: 'flex-start',
			}}>
			{children}
		</View>
	)
}

export default TableColumns
